import { gsap } from "../LibrariesImport";

export default class BlockTextAnimation {

    static init() {
        const blocks = document.querySelectorAll(".block-text-animation");

        if (blocks.length < 1) {
            return;
        }

        blocks.forEach(block => {
            this.initBlockAnimations(block);
        });
    }

    static initBlockAnimations(block) {
        const items = document.querySelectorAll(".keywords li");

        if (items.length < 1) {
            return;
        }

        let currentIndex = 0;

        // Animation de flottement pour tous les éléments
        items.forEach((item) => {
            // Configuration initiale
            gsap.set(item.querySelector(".secondary"), {
                opacity: 0,
                height: 0,
            });

            const getRandomFloat = (min, max) => {
                return Math.random() * (max - min) + min;
            };


            // Animation de flottement
            gsap.to(item.querySelector(".item"), {
                y: "+=10%",
                duration: getRandomFloat(1.5, 2),
                repeat: -1,
                yoyo: true,
                ease: "sine.inOut",
                // Décalage aléatoire pour chaque élément
                delay: getRandomFloat(1.5, 2)
            });
        });


        // Ajouter la classe active au premier élément
        items[0].classList.add('active');

        gsap.to({}, {
            duration: 3,
            repeat: -1,
            onRepeat: () => {
                gsap.to(items[currentIndex].querySelector(".secondary"), {
                    opacity: 0,
                    height: 0,
                    duration: 0.3,
                    ease: "power2.out"
                });

                gsap.to(items[currentIndex].querySelector(".picto"), {
                    scale: 1,
                    duration: 0.3,
                    ease: "power2.out"
                });

                // Retirer la classe active de l'élément courant
                items[currentIndex].classList.remove('active');

                // Passer à l'élément suivant (retour au début si on atteint la fin)
                currentIndex = (currentIndex + 1) % items.length;

                // Ajouter la classe active au nouvel élément
                items[currentIndex].classList.add('active');

                // Animer le nouvel élément .secondary
                gsap.to(items[currentIndex].querySelector(".secondary"), {
                    opacity: 1,
                    height: "auto",
                    duration: 0.6,
                    ease: "elastic.out(1, 0.5)"
                });

                gsap.to(items[currentIndex].querySelector(".picto"), {
                    scale: 1.2,
                    duration: 0.6,
                    ease: "elastic.out(1, 0.5)"
                });
            }
        });

    }
}